export default __webpack_public_path__ + "static/media/trigoOutside.437f492d.png";